var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlights({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 135 135",
    width: 135,
    height: 135,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flightschedule") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #003265 } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m114.5 7.2q8.6-2.9 13.2 1.1 4 4.6 1.1 13.2-2.9 8.5-9.6 15.3l-14.4 14.4 14.3 62.1q0.4 1.7-1.1 3l-11.4 8.5q-0.6 0.6-1.7 0.6-0.4 0-0.6-0.1-1.4-0.3-1.9-1.4l-24.9-45.4-23.1 23.1 4.7 17.3q0.5 1.6-0.7 2.8l-8.5 8.6q-0.8 0.8-2.1 0.8h-0.2q-1.3-0.2-2.1-1.2l-16.9-22.5-22.4-16.8q-1-0.7-1.2-2.1-0.1-1.2 0.8-2.2l8.6-8.7q0.8-0.8 2-0.8 0.6 0 0.7 0.1l17.3 4.7 23.1-23.1-45.3-24.9q-1.2-0.7-1.5-2.1-0.2-1.5 0.8-2.4l11.4-11.5q1.3-1.1 2.7-0.7l59.3 14.2 14.3-14.3q6.8-6.7 15.3-9.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlights);
export default __webpack_public_path__ + "static/media/flights.7aee6194ecd1f88b20e1b30e1188ca31.svg";
export { ForwardRef as ReactComponent };